module.exports = __webpack_public_path__ + "img/icon_menu.bf1c02b.webp";